module.exports = __webpack_public_path__ + "static/media/Experiencia.bf57e0da.svg";